import type { PayloadError } from 'relay-runtime';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

type PayloadExtensions = {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
};

// A relay error including AGG's `extensions` (which `PayloadError` omits), without narrowing `path`
// so `response.errors` assigns to it without a cast.
export type CapturedError = PayloadError & {
	extensions?: PayloadExtensions;
};

// An operation's latest response errors plus the AGG gateway ids (for Splunk / AGG log lookup).
export type CapturedResponse = {
	errors: readonly CapturedError[];
	requestId?: string;
	traceId?: string;
};

type ErrorMeta = {
	operationName: string;
	requestId?: string;
	traceId?: string;
};

// Latest captured response per operation, so a consumer can read a masked error after the fact
// without owning the (preloaded) query's lifecycle.
const store = new Map<string, CapturedResponse>();

autoBeforeEachTest(() => {
	store.clear();
});

// Called for every captured response; an error-free one clears the entry so the store always
// reflects the operation's most recent response.
export const recordLatestErrors = (
	errors: readonly CapturedError[] | null,
	meta: ErrorMeta,
): void => {
	if (errors && errors.length > 0) {
		store.set(meta.operationName, { errors, requestId: meta.requestId, traceId: meta.traceId });
	} else {
		store.delete(meta.operationName);
	}
};

export const getLatestErrors = (operationName: string): CapturedResponse | null =>
	store.get(operationName) ?? null;

export const clearLatestErrors = (operationName: string): void => {
	store.delete(operationName);
};
